// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4980d88","239":"4a41bfb1","622":"b9347803","938":"d7e4b086"}[chunkId] + ".chunk.js";
};